module.exports = __webpack_public_path__ + "static/media/photo7-4.0d36363e.webp";